import React, { useState, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Autocomplete } from '@material-ui/lab';

import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Editor } from 'react-draft-wysiwyg'
//import Editor from 'draft-js-plugins-editor';
import createImagePlugin from 'draft-js-image-plugin';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


// import createImagePlugin from 'draft-js-image-plugin';
// import createDragNDropUploadPlugin from 'draft-js-drag-n-drop-upload-plugin';


import { Button, TextField, Checkbox, Paper, Grid, MenuItem, Container, CircularProgress } from '@material-ui/core';

import { getSelectOptions } from '../../shared/helpers/selectHelper';
import { distinct } from '../../shared/helpers/distinctArray';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import emailService from '../../api/emailService';

const imagePlugin = createImagePlugin();


const EmailScreen = ({ categories }) => {
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [title, setTitle] = useState('');
    const [sendToAll, setSendToAll] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubcategory, setSelectedSubcategory] = useState('');
    const [destinations, setDestinations] = useState([]);

    const [isLoadingEmails, setIsLoadingEmails] = useState(false);
    const [emailsLoaded, setEmailsLoaded] = useState(false);
    const [usersEmails, setUsersEmails] = useState(false);

    useEffect(() => {
        if (!isLoadingEmails && !emailsLoaded) {
            setIsLoadingEmails(true);
            emailService.getUsersEmail()
                .then((emails) => {
                    setUsersEmails(emails);
                    setIsLoadingEmails(false);
                    setEmailsLoaded(true);
                })
                .catch(() => {
                    setUsersEmails([]);
                    setIsLoadingEmails(false);
                    setEmailsLoaded(true);
                });
        }
    }, [isLoadingEmails, emailsLoaded]);

    const subcategories = useMemo(() => {
        const catSelected = categories.filter((cat) => cat.name === selectedCategory);
        if (catSelected.length <= 0) {
            return [];
        }
        return catSelected[0].subcategories;
    }, [categories, selectedCategory]);

    const contentBlock = htmlToDraft('');
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));

    function getHtmlBody() {
        const context = editorState.getCurrentContent();
        const raw = convertToRaw(context);
        const html = draftToHtml(raw);
        console.log(html);
        return html;
    }

    function sendEmail() {
        setIsSendingEmail(true);
        const body = getHtmlBody();
        emailService.sendEmail(title, body, sendToAll, destinations, selectedCategory, selectedSubcategory)
            .then(() => {
                setIsSendingEmail(false);
            })
            .catch(() => {
                setIsSendingEmail(false);
            });
    }

    return (
        <Paper>
            <Container style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Typography variant='h4'
                    margin='normal'
                    style={{ margin: 10 }}>Send WhatsApp</Typography>
                <div>
                    <FormControlLabel value="end"
                        control={
                            <Checkbox color="secondary"
                                value={sendToAll}
                                onChange={({ target }) => setSendToAll(target.checked)} />
                        }
                        label="Send to all users"
                        labelPlacement="end"
                        style={{ margin: 0 }} />
                </div>


                {
                    !sendToAll &&
                    <>
                        <Grid container>
                            <Grid item xs={12} sm={6} style={{ padding: 5 }}>
                                <TextField select
                                    margin="normal"
                                    variant="outlined"
                                    label="Category"
                                    value={selectedCategory}
                                    onChange={({ target }) => setSelectedCategory(target.value)}
                                    fullWidth
                                >
                                    {[<MenuItem value={""}>Choose a category...</MenuItem>, getSelectOptions(categories.map((category) => ({ value: category.name, display: category.name })))]}
                                </TextField>
                            </Grid>


                            <Grid item xs={12} sm={6} style={{ padding: 5 }}>
                                <TextField select
                                    margin="normal"
                                    variant="outlined"
                                    label="Subcategory"
                                    value={selectedSubcategory}
                                    onChange={({ target }) => setSelectedSubcategory(target.value)}
                                    fullWidth
                                >
                                    {[<MenuItem value={""}>Choose a subcategory...</MenuItem>, getSelectOptions(subcategories.map((category) => ({ value: category.name, display: category.name })))]}

                                </TextField>
                            </Grid>
                            <Grid item xs={12} style={{ padding: 5 }}>
                                <Autocomplete
                                    multiple
                                    id="tags-destinations"
                                    loading={isLoadingEmails && !emailsLoaded}
                                    loadingText="Loading users' email"
                                    onChange={(evt, values) => {
                                        setDestinations(values);
                                    }}
                                    options={usersEmails}
                                    getOptionLabel={option => option}
                                    value={destinations}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Destinations"
                                            fullWidth
                                            type="text"
                                            variant="outlined"
                                            margin="normal"
                                        />
                                    )}
                                />

                            </Grid>
                        </Grid>
                    </>
                }
                <div style={{ padding: 5 }}>
                    <TextField label="Title"
                        fullWidth
                        type="text"
                        variant="outlined"
                        margin="normal"
                        value={title}
                        onChange={({ target }) => setTitle(target.value)}
                    />
                </div>
                <div>
                    <Editor editorState={editorState}
                        plugins={[imagePlugin]}
                        toolbar={{
                            options: ['inline', 'blockType', 'colorPicker', 'fontSize', 'fontFamily', 'list', 'textAlign', 'emoji', 'image', 'history'],
                            image: {
                                uploadEnabled: true,
                                previewImage: true,
                                uploadCallback: async (image) => {
                                    const link = await emailService.uploadImage(image);
                                    return { data: { link } };
                                },
                                urlEnabled: false
                            }
                        }}
                        wrapperStyle={{ padding: 10, border: '1px solid #c2c2c2', borderRadius: 4, margin: 10 }}
                        onEditorStateChange={(editorState) => {
                            setEditorState(editorState);
                        }} />
                </div>

                {/* <TextField label="Text"
                    type="text"
                    disabled
                    value={body}
                    variant="outlined"
                    style={{
                        margin: 8,
                        width: 700
                    }}
                    rows="5"
                    fullWidth
                multiline />*/}
                <div>
                    <Button variant="contained"
                        color="secondary"
                        margin="normal"
                        disabled={isSendingEmail}
                        style={{ margin: 8 }}
                        onClick={sendEmail}
                        endIcon={isSendingEmail ? <CircularProgress /> : <Icon>send</Icon>}
                    >Send</Button>
                </div>
            </Container>
        </Paper>

    )

}

const mapStateToProps = ({ categoryState, locationState }) => ({
    categories: categoryState.categories
});

export default connect(mapStateToProps)(EmailScreen);